import React from "react"

const t = (key: string) => window.i18n.t(key)

export interface IncludeExcludeTagProps {
  /** The display label for the tag */
  label: string
  /** Whether this item is included (true) or excluded (false) */
  isIncluded: boolean
  /** Callback when the include/exclude toggle is clicked */
  onToggle: () => void
  /** Callback when the remove button is clicked */
  onRemove: () => void
  /** Optional title attribute for the tag (defaults to label) */
  title?: string
}

/**
 * A reusable tag component with include/exclude toggle buttons.
 * Used across multiple filter components for consistent UX.
 */
export function IncludeExcludeTag({
  label,
  isIncluded,
  onToggle,
  onRemove,
  title,
}: IncludeExcludeTagProps) {
  return (
    <div className="tags-list flex-nowrap mt-2">
      <span
        className={`tag tag--dissmissable${!isIncluded ? " tag--danger" : ""}`}
        title={title || label}
      >
        <span className="tag__label">{label}</span>
        <button
          type="button"
          className="tag__dissmiss"
          onClick={onRemove}
          aria-label={t("js.back.discover.filters.remove")}
        >
          <i className="tag__dissmiss-icon far fa-times" aria-hidden="true" />
        </button>
      </span>
      <div className="tags-list__actions">
        <button
          type="button"
          className={`tags-list__action ${isIncluded ? "active" : ""}`}
          onClick={onToggle}
        >
          {t("js.back.discover.filters.include")}
        </button>
        <button
          type="button"
          className={`tags-list__action ${!isIncluded ? "active" : ""}`}
          onClick={onToggle}
        >
          {t("js.back.discover.filters.exclude")}
        </button>
      </div>
    </div>
  )
}
